import { DashboardContainer } from '@forwardflow/components/Dashboard'
import { Outlet, useNavigate, useParams } from 'react-router-dom'
import { NavigationBar } from './NavigationBar'
import { TopBar } from './TopBar'
import { LeadSourceInfo } from './LeadSourceInfo'
import { useEffect, useState } from 'react'
import Icon from '@forwardflow/ui/Icons'
import { Progress } from 'antd'
import CampaignService from '@forwardflow/services/CampaignService'
import { TopBarIdle } from './TopBarIdle'

export const ActivateCampaignPage = () => {
   const [loading, setLoading] = useState(true)
   const [progress, setProgress] = useState(0)
   const [currentStep, setCurrentStep] = useState(1)
   const { title } = useParams()
   const [campaignId, setCampaignId] = useState<string>('')
   const [campaignName, setCampaignName] = useState<string>('')
   const [isCampaignCreated, setIsCampaignCreated] = useState(false)
   const navigate = useNavigate()
   const handleCampaignCreation = async () => {
      if (title) {
         startProgress()
         try {
            const responseActiveLeadSource: any =
               await CampaignService.createActiveLeadSource(title as string)
            if (responseActiveLeadSource) {
               setIsCampaignCreated(true)
               setCampaignName(responseActiveLeadSource.campaignName)
               setCampaignId(responseActiveLeadSource.id)
            }
         } catch (error) {
            console.error('Error creating campaign:', error)
            setIsCampaignCreated(true)
         }
      }
   }

   useEffect(() => {
      handleCampaignCreation()
   }, [])

   useEffect(() => {
      if (progress === 100 && isCampaignCreated) {
         setLoading(false)
         navigate(
            `/campaign/${encodeURIComponent(
               campaignId
            )}/phone-number?campaignName=${campaignName}`
         )
      }
   }, [isCampaignCreated, progress])

   const startProgress = () => {
      const duration = 5000
      const steps = 100
      let currentProgress = 0

      const timer = setInterval(() => {
         currentProgress += 1
         setProgress(currentProgress)

         // Update steps at specific progress points
         if (currentProgress === 33) setCurrentStep(2)
         if (currentProgress === 66) setCurrentStep(3)

         if (currentProgress >= steps) {
            clearInterval(timer)
         }
      }, duration / steps)
   }

   const renderStep = () => {
      switch (currentStep) {
         case 1:
            return (
               <>
                  <Icon name="Filters" className="mb-12 scale-[5] opacity-50" />
                  <p className="mt-12 text-white/50">1/3</p>
                  <p className="text-[32px] mb-8">Analyzing Lead Source</p>
               </>
            )
         case 2:
            return (
               <>
                  <Icon
                     name="Telephone"
                     className="mb-12 scale-[5] opacity-50 fill-white/20"
                  />
                  <p className="mt-12 text-white/50">2/3</p>
                  <p className="text-[32px] mb-8">Adding Phone Numbers</p>
               </>
            )
         case 3:
            return (
               <>
                  <Icon
                     name="Person"
                     className="mb-12 scale-[5] opacity-50 fill-white/20"
                  />
                  <p className="mt-12 text-white/50">3/3</p>
                  <p className="text-[32px] mb-8">Creating Sales Assistants</p>
               </>
            )
      }
   }
   return (
      <DashboardContainer>
         <div className="flex flex-col h-full">
            {!loading ? (
               <>
                  <TopBar />
                  <div className="flex gap-5 mt-5 flex-1 min-h-0 overflow-hidden">
                     <LeadSourceInfo />
                     <div className="flex flex-1 bg-primary/10 rounded-xl">
                        <NavigationBar />
                        <Outlet />
                     </div>
                  </div>
               </>
            ) : (
               <>
                  <TopBarIdle />
                  <div className="flex flex-col items-center justify-center flex-1 min-h-0 font-medium">
                     {renderStep()}
                     <Progress
                        percent={progress}
                        showInfo={false}
                        className="max-w-[600px] mb-7"
                        trailColor="rgba(255,255,255,.10)"
                        strokeColor={{
                           '0%': 'rgba(255,255,255,.20)',
                           '100%': 'rgba(255,255,255,.20)',
                        }}
                     />
                     <p className="text-white/50 mb-7">
                        Hang tight, this will just take a moment!
                     </p>
                  </div>
               </>
            )}
         </div>
      </DashboardContainer>
   )
}
